import { render, staticRenderFns } from "./BlockType28.vue?vue&type=template&id=3632199b&scoped=true"
import script from "./BlockType28.vue?vue&type=script&lang=ts"
export * from "./BlockType28.vue?vue&type=script&lang=ts"
import style0 from "./BlockType28.vue?vue&type=style&index=0&id=3632199b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3632199b",
  null
  
)

export default component.exports